/*
创建者 李伟(2018.1.24)
*/
<template>
  <div class="shop-index">
    <shop_header
      :head-data="headData"
      @newKeyword="changeKeyword"
      @getShopListData="getShopListData"
      @applyHeadData="applyHeadData"
      :isHasShop="isHasShop"
    ></shop_header>
    <div
      class="no-shop"
      v-if="!isHasShop"
    >抱歉，暂无相关店铺!</div>
    <div
      class="shop-nav"
      v-if="isHasShop"
    >
      <ul class="pngFix">
        <li
          v-for="(row,index) in navList"
          v-bind:class="{'active':index==tab-1}"
          :key="index"
        >
          <a v-on:click="changeTab(row.tab)">
            {{row.name}}
          </a>
        </li>
      </ul>
    </div>
    <!--店铺首页-->
    <div
      v-if="tab=='1' && isHasShop"
      class="pb20"
    >
      <div
        class="swipe-wrap"
        id="shopswiper"
      >
        <Carousel
          v-if="sildeList.length"
          v-model="shopBanner"
          :autoplay="setting.autoplay"
          :autoplay-speed="setting.autoplaySpeed"
          :dots="setting.dots"
          :radius-dot="setting.radiusDot"
          :trigger="setting.trigger"
          :arrow="setting.arrow"
        >
          <CarouselItem
            v-for="(row,index) in sildeList"
            :key="index"
          >
            <div
              class="demo-carousel"
              style="cursor:pointer;"
              @click="gotoTarget(row)"
            ><img
                :src="row.img"
                height="480"
                width="1000"
              /></div>
          </CarouselItem>
        </Carousel>
        <div
          class="shop-item"
          v-if="specialRecommendGoods.length > 0"
        >
          <div class="title mt20">
            <span><a
                class="more"
                v-on:click="changeTab(2,8)"
              >更多&gt;&gt;</a></span>
            <h4>特别推荐商品</h4>
          </div>
          <div class="shop-hot-list">
            <ul class="clearfix">
              <li v-for="row in specialRecommendGoods">
                <dl>
                  <dd class="ncg-pic pngFix">
                    <router-link
                      :to="{ path: 'goods', query: { goods_id: row.goodsId}}"
                      class="thumb"
                    >
                      <i></i>
                      <img
                        :src="row.thumbnail"
                        height="195"
                        width="195"
                      >
                    </router-link>
                  </dd>
                  <dt>
                    <router-link
                      :to="{ path: 'goods', query: { goods_id: row.goodsId}}"
                      v-bind:title="row.name"
                    >
                      {{row.name}}
                    </router-link>
                  </dt>
                  <dd class="ncg-price">
                    <em class="price"><i>¥</i>{{row.price}}</em>
                  </dd>
                  <dd class="ncg-sold">
                    已销售：<strong>{{row.buyNum}}</strong> 件
                  </dd>
                </dl>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="shop-item"
          v-if="hotSellGoods.length > 0"
        >
          <div class="title mt20">
            <span><a
                class="more"
                v-on:click="changeTab(2,9)"
              >更多&gt;&gt;</a></span>
            <h4>热销商品排行</h4>
          </div>
          <div class="shop-com-list">
            <ul class="clearfix">
              <li v-for="row in hotSellGoods">
                <dl>
                  <dd class="ncg-pic pngFix">
                    <router-link
                      :to="{ path: 'goods', query: { goods_id: row.goodsId}}"
                      class="thumb"
                    >
                      <i></i>
                      <img
                        :src="row.thumbnail"
                        height="160"
                        width="160"
                      >
                    </router-link>
                  </dd>
                  <dt>
                    <router-link
                      :to="{ path: 'goods', query: { goods_id: row.goodsId}}"
                      v-bind:title="row.name"
                    >
                      {{row.name}}
                    </router-link>
                  </dt>
                  <dd class="ncg-price">
                    <em class="price"><i>¥</i>{{row.price}}</em>
                  </dd>
                  <dd class="ncg-sold">
                    已销售：<strong>{{row.buyNum}}</strong> 件
                  </dd>
                </dl>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="shop-item"
          v-if="newGoods.length > 0"
        >
          <div class="title mt20">
            <span><a
                class="more"
                v-on:click="changeTab(2,10)"
              >更多&gt;&gt;</a></span>
            <h4>新品</h4>
          </div>
          <div class="shop-new-list">
            <ul class="clearfix">
              <li v-for="row in newGoods">
                <dl>
                  <dd class="ncg-pic pngFix">
                    <router-link
                      :to="{ path: 'goods', query: { goods_id: row.goodsId}}"
                      class="thumb"
                    >
                      <i></i>
                      <img
                        :src="row.thumbnail"
                        height="200"
                        width="200"
                      >
                    </router-link>
                  </dd>
                  <dt>
                    <router-link
                      :to="{ path: 'goods', query: { goods_id: row.goodsId}}"
                      v-bind:title="row.name"
                    >
                      {{row.name}}
                    </router-link>
                  </dt>
                  <dd class="ncg-price">
                    <em class="price"><i>¥</i>{{row.price}}</em>
                  </dd>
                  <dd class="ncg-sold">
                    已销售：<strong>{{row.buyNum}}</strong> 件
                  </dd>
                </dl>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="shop-item"
          v-if="recommendGoods.length > 0"
        >
          <div class="title mt20">
            <span><a
                class="more"
                v-on:click="changeTab(2,11)"
              >更多&gt;&gt;</a></span>
            <h4>推荐商品</h4>
          </div>
          <div class="shop-com-list">
            <ul class="clearfix">
              <li v-for="row in recommendGoods">
                <dl>
                  <dd class="ncg-pic pngFix">
                    <router-link
                      :to="{ path: 'goods', query: { goods_id: row.goodsId}}"
                      class="thumb"
                    >
                      <i></i>
                      <img
                        :src="row.thumbnail"
                        height="160"
                        width="160"
                      >
                    </router-link>
                  </dd>
                  <dt>
                    <router-link
                      :to="{ path: 'goods', query: { goods_id: row.goodsId}}"
                      v-bind:title="row.name"
                    >
                      {{row.name}}
                    </router-link>
                  </dt>
                  <dd class="ncg-price">
                    <em class="price"><i>¥</i>{{row.price}}</em>
                  </dd>
                  <dd class="ncg-sold">
                    已销售：<strong>{{row.buyNum}}</strong> 件
                  </dd>
                </dl>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--全部商品列表-->
    <div
      v-if="tab=='2' && isHasShop"
      class="nc-goods-main shop-container"
    >
      <!-- 商品分类 -->
      <div class="left-card mt10">
        <div class="classify card">
          <div class="title">商品分类</div>
          <div class="content">
            <div v-for="item in catListData">
              <span @click.stop.prevent="toggle(item)"><em v-show="item.show">-</em><em v-show="!item.show">+</em></span>
              <a
                @click.stop.prevent="setNavigationTag(item)"
                :title="item.storeCatName"
                v-bind:class="{'active':priceFormData.acid == item.storeCatId && priceFormData.pid==''}"
              >{{item.storeCatName | limitToNum(10)}}</a>
              <div v-show="item.show">
                <a
                  style="display: block;padding-left: 26px;font-weight: normal;"
                  :title="item.storeCatName"
                  v-bind:class="{'active':priceFormData.acid == item.storeCatId && priceFormData.pid==item.storeCatPid}"
                  v-for="item in item.list"
                  @click.stop.prevent="setNavigationTag(item)"
                >
                  • {{item.storeCatName | limitToNum(10)}}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nc-s-c-s3 ncg-list mt10">
        <!--<div class="title pngFix"><h4>商品类型</h4></div>
        <div class="navigationTag">
          <span v-for="(row,index) in navigationTag" v-if="row.storeCatPid==0"
                v-bind:class="{'active':row.storeCatId ==priceFormData.acid }"
                v-on:click="setNavigationTag(row,index)">{{row.storeCatName}}</span>
        </div>-->
        <div class="ncs-goodslist-bar">
          <ul class="ncs-array">
            <li
              v-for="(row,index) in setFormData"
              v-bind:class="{'active':index==priceFormData.key-1,'desc':index==priceFormData.key-1 && priceFormData.order=='asc','asc':index==priceFormData.key-1 && priceFormData.order=='desc'}"
              v-on:click="setForm(row.key)"
            ><a class="sort-indicator">{{row.name}}</a></li>
          </ul>
          <div class="price-search">
            <em>￥</em>&nbsp;
            <input
              type="text"
              class="w30"
              v-model="priceFormData.start_price"
              @input="handleInput"
            ></input><i>-</i>
            <input
              type="text"
              class="w30"
              v-model="priceFormData.end_price"
              @input="handleInput"
            ></input>
            <a v-on:click="priceSearch()">搜索</a>
          </div>
        </div>
        <div class="content">
          <div
            class="squares"
            nc_type="current_display_mode"
            style="padding-top:30px"
          >
            <div
              v-if="shopList.length===0"
              nc_type="current_display_mode"
            ><span style="color:red;font-size:20px">抱歉,暂无此类商品!</span>
            </div>
            <ul v-else>
              <li v-for="row in shopList">
                <dl>
                  <dt>
                    <router-link
                      :to="{ path: 'goods', query: { goods_id: row.goodsId}}"
                      v-bind:title="row.name"
                    >
                      {{row.name}}
                    </router-link>
                  </dt>
                  <dd class="ncg-pic pngFix">
                    <router-link
                      class="thumb size160"
                      :to="{ path: 'goods', query: { goods_id: row.goodsId}}"
                      v-bind:title="row.name"
                    ><i></i>
                      <img
                        :src="row.thumbnail"
                        :title="row.name"
                        height="160"
                        style="display: inline;"
                        width="160"
                      >
                    </router-link>
                  </dd>
                  <dd class="ncg-price">
                    <em class="price">￥{{row.price}}</em>
                  </dd>
                  <dd class="ncg-sold">
                    售出：<strong>{{row.buyNum}}</strong> 件
                  </dd>
                </dl>
              </li>
            </ul>
          </div>
        </div>
        <div class="pb20 floatr">
          <Page
            ref="pages"
            :total="dataTotal"
            :page-size="pageSize"
            @on-change="changepage"
            show-elevator
          ></Page>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <!--信用评价-->
    <div
      v-if="tab=='3' && isHasShop"
      class="shop-container"
    >
      <div class="nc-s-c-s3 ncs-comment mt10">
        <div class="personal-rating">
          <div class="title">
            <h4>店铺动态评分</h4>
          </div>
          <table
            class="seller-rate-info mt20"
            id="sixmonth"
          >
            <tbody>
              <tr>
                <th>
                  <p>宝贝与描述相符</p>
                  <p class="rate-star mt5"><em><i v-bind:style="{ width: shopCredit.storeDesccredit/5*100 + '%'}"></i></em></p>
                </th>
                <td>
                  <dl class="ncs-rate-column">
                    <dt><em v-bind:style="{ left: shopCredit.storeDesccredit/5*100 + '%'}">{{shopCredit.storeDesccredit}}</em>
                    </dt>
                    <dd v-for="row in containerData">{{row.name}}</dd>
                  </dl>
                </td>
              </tr>
              <tr>
                <th>
                  <p>卖家的服务态度</p>
                  <p class="rate-star mt5"><em><i v-bind:style="{ width: shopCredit.storeServicecredit/5*100 + '%'}"></i></em>
                  </p>
                </th>
                <td>
                  <dl class="ncs-rate-column">
                    <dt><em v-bind:style="{ left: shopCredit.storeServicecredit/5*100 + '%'}">{{shopCredit.storeServicecredit}}</em>
                    </dt>
                    <dd v-for="row in containerData">{{row.name}}</dd>
                  </dl>
                </td>
              </tr>
              <tr>
                <th>
                  <p>卖家的发货速度</p>
                  <p class="rate-star mt5"><em><i v-bind:style="{ width: shopCredit.storeDeliverycredit/5*100 + '%'}"></i></em></p>
                </th>
                <td>
                  <dl class="ncs-rate-column">
                    <dt><em v-bind:style="{ left: shopCredit.storeDeliverycredit/5*100 + '%'}">{{shopCredit.storeDeliverycredit}}</em>
                    </dt>
                    <dd v-for="row in containerData">{{row.name}}</dd>
                  </dl>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--店铺详情-->
    <div
      v-if="tab=='4' && isHasShop"
      class="shop-container"
    >
      <section class="layout">
        <article class="nc-goods-main">
          <div class="nc-s-c-s3 mt10">
            <div class="title">
              <h4>店铺详情</h4>
            </div>
            <div class="content pt10 pb20 clearfix">
              <!--店铺基本信息 -->
              <div class="ncs-info clearfix">
                <div class="shop-card">
                  <h4>店铺</h4>
                  <dl>
                    <dt>
                      <span class="thumb size60"><i></i>
                        <a href="#4">
                          <img
                            :src="shopInfoData.storeLogo"
                            :title="shopInfoData.storeName"
                            height="50px"
                            width="50px"
                            class="pngFix"
                          > </a> </span>
                    </dt>
                    <dd>
                      {{shopInfoData.storeName}}
                    </dd>
                    <dd class="ncs-level">卖家信用：{{shopInfoData.storeCredit}}</dd>
                    <dd>
                      <span>好评率：</span>{{shopInfoData.praiseRate}}%
                    </dd>
                  </dl>
                </div>
                <div class="shop-rate">
                  <h4>动态评价</h4>
                  <!-- 动态评价 -->
                  <dl class="rate">
                    <dt>描述相符：</dt>
                    <dd class="rate-star evaluate">
                      <em><i v-bind:style="{ width: shopCredit.storeDesccredit/5*100 + '%'}"></i>
                      </em>
                    </dd>
                    <dt>服务态度：</dt>
                    <dd class="rate-star evaluate">
                      <em><i v-bind:style="{ width: shopCredit.storeDervicecredit/5*100 + '%'}"></i>
                      </em>
                    </dd>
                    <dt>发货速度：</dt>
                    <dd class="rate-star evaluate">
                      <em><i v-bind:style="{ width: shopCredit.storeDeliverycredit/5*100 + '%'}"></i>
                      </em>
                    </dd>
                  </dl>
                </div>
                <div class="shop-detail">
                  <!-- 店铺信息 -->
                  <h4>店铺信息</h4>
                  <dl>
                    <dt>创店时间：</dt>
                    <dd>{{shopInfoData.passTime}}</dd>
                    <dt>所&nbsp;在&nbsp;地：</dt>
                    <dd>
                      {{shopInfoData.storeProvince}}&nbsp;{{shopInfoData.storeCity}}&nbsp;{{shopInfoData.storeRegion}}&nbsp;{{shopInfoData.storeVillages}}
                    </dd>
                    <dt>商品数量：</dt>
                    <dd>
                      <strong>{{shopInfoData.normalGoodsNum}}</strong>件商品
                    </dd>
                    <dt>店铺收藏：</dt>
                    <dd>
                      <strong nctype="store_collect">{{shopInfoData.storeCollect}}</strong>人收藏
                    </dd>
                    <dt>认证信息：</dt>
                    <dd>
                      <img
                        v-if="shopInfoData.storeAuth==1"
                        src="//static.kxymall.com/images/cert_autonym.gif"
                        title="身份已认证"
                        alt="身份已认证"
                      >
                      <img
                        v-if="shopInfoData.storeAuth==1"
                        src="//static.kxymall.com/images/cert_material.gif"
                        title="店铺已认证"
                        alt="店铺已认证"
                      >
                      <img
                        v-if="shopInfoData.storeAuth!=1"
                        src="//static.kxymall.com/images/cert_autonym_no.gif"
                        title="身份未认证或认证失败"
                        alt="身份未认证或认证失败"
                      >
                      <img
                        v-if="shopInfoData.storeAuth!=1"
                        src="//static.kxymall.com/images/cert_material_no.gif"
                        title="尚未认证或认证失败"
                        alt="尚未认证或认证失败"
                      >
                    </dd>
                  </dl>
                </div>
                <div class="shop-im">
                  <h4>联系方式</h4>
                  <p>联系电话：{{shopInfoData.tel}}</p>
                </div>
                <div class="shop-im" v-if="shopInfoData.licenseImg">
                  <h4>营业执照</h4>
                  <a :href="shopInfoData.licenseImg" target="_blank"><img
                    style="width: 120px"
                    :src="shopInfoData.licenseImg"
                    title="营业执照"
                    alt=""
                  ></a>

                </div>
              </div>
              <div class="ncu-intro">
                <div class="top"></div>
                <div class="content clearfix">
                  <h2 class="ncu-name">{{headData.storeName}}</h2>
                  <dl class="ncu-shop-info">
                    <dt>
                      <span class="thumb size80"><i></i>
                        <a href="javascript:void(0);">
                          <img
                            :src="shopInfoData.storeLogo"
                            id="logo"
                            height="80"
                            width="80"
                          >
                        </a>
                      </span>
                    </dt>
                    <dd class="base">
                      <p>店铺名称：{{shopInfoData.storeName}}</p>
                      <!-- 店铺名称 -->
                      <p>店铺等级：{{membershipLevelName}}</p>
                      <!-- 店铺等级 -->
                      <p>
                        <span class="fl">认证信息：</span>
                        <!-- 认证信息 -->
                        <img
                          v-if="shopInfoData.storeAuth==1"
                          src="//static.kxymall.com/images/cert_autonym.gif"
                          title="身份已认证"
                          alt="身份已认证"
                        >
                        <img
                          v-if="shopInfoData.storeAuth==1"
                          src="//static.kxymall.com/images/cert_material.gif"
                          title="店铺已认证"
                          alt="店铺已认证"
                        >
                        <img
                          v-if="shopInfoData.storeAuth!=1"
                          src="//static.kxymall.com/images/cert_autonym_no.gif"
                          title="身份未认证或认证失败"
                          alt="身份未认证或认证失败"
                        >
                        <img
                          v-if="shopInfoData.storeAuth!=1"
                          src="//static.kxymall.com/images/cert_material_no.gif"
                          title="尚未认证或认证失败"
                          alt="尚未认证或认证失败"
                        >
                      </p>
                    </dd>
                  </dl>
                  <dl class="nus-basic-info">
                    <dt>基本信息</dt>
                    <!-- 基本信息 -->
                    <dd>
                      <span style="float: left;">卖家信用：</span> {{shopInfoData.storeCredit}}
                    </dd>
                    <!-- <dd>商品信息：出售中的商品</dd> -->
                    <dd>注册时间：{{shopInfoData.passTime}}</dd>
                  </dl>
                  <dl
                    class="nus-contact"
                    style="overflow: hidden"
                  >
                    <dt>联系方式</dt>
                    <!-- 联系方式 -->
                    <dd>
                      所&nbsp;在&nbsp;地：{{shopInfoData.storeProvince}}&nbsp;{{shopInfoData.storeCity}}&nbsp;{{shopInfoData.storeRegion}}&nbsp;{{shopInfoData.storeVillages}}
                    </dd>
                    <dd>详细地址：{{shopInfoData.attr}}</dd>
                    <dd>联系电话：{{shopInfoData.tel}}</dd>
                    <dd><span>店铺简介：</span>
                      <p
                        style="padding: 0px; margin: 0px;"
                        v-html="shopInfoData.description"
                      ></p>
                    </dd>
                  </dl>
                  <img
                    :src="shopInfoData.storeBanner"
                    id="img_store_banner"
                    height="158"
                    width="610"
                  >
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
    </div>
    <!--店铺实体图片-->
    <div
      v-if="tab=='5' && isHasShop"
      class="shop-container flexslider "
    >
      <Carousel
        v-model="entityPicture"
        :autoplay="setting.autoplay"
        :autoplay-speed="setting.autoplaySpeed"
        :dots="'outside'"
        :radius-dot="true"
        :trigger="setting.trigger"
        :arrow="setting.arrow"
      >
        <CarouselItem
          v-for="(row,index) in shopImgsList"
          :key="index"
        >
          <div class="demo-carousel"><img
              :src="row.storeImgsUrl"
              height="444"
              width="790"
            /></div>
        </CarouselItem>
      </Carousel>
    </div>
  </div>

</template>

<script>
import {
  getStoreIndexDetail,
  getStoreGoodList,
  getStoreDetail,
  getStoreImgs,
} from "api/shop.js";
import { getMemberLevel } from "api/user";
import { getAllCatList } from "@/api/goods";
import { limitToNum } from "api/index.js";
import { parseAdvList, getQueryObject } from "utils/tool";
import shop_header from "views/common/layout/shop_header.vue";

export default {
  props: ["HeadData"],
  components: {
    shop_header,
  },
  data() {
    let query = getQueryObject();
    return {
      query: query,
      dataTotal: 0,
      shopList: {},
      shopInfoData: {},
      pageSize: 12,
      keyword: "",
      shopBanner: 0,
      entityPicture: 0,
      setting: {
        autoplay: true,
        autoplaySpeed: 2000,
        dots: "inside",
        radiusDot: false,
        trigger: "hover",
        arrow: "hover",
      },
      headDataFlag: false,
      headData: {},
      shopCredit: {},
      tab: 1,
      tagid: "",
      stc_id: "",
      priceFormData: {
        key: "",
        oldKey: "",
        order: "",
        start_price: "",
        end_price: "",
        pid: "",
        acid: "",
      },
      store_id: parseInt(this.$route.query.store_id),
      //                  navList:[{name:'首页',tab:'1'},{name:'全部商品',tab:'2'},{name:'信用评价',tab:'3'},{name:'店铺详情',tab:'4'},{name:'实体图片',tab:'5'}],
      navList: [
        { name: "首页", tab: "1" },
        { name: "全部商品", tab: "2" },
        { name: "信用评价", tab: "3" },
        { name: "店铺详情", tab: "4" },
      ],
      setFormData: [
        { name: "销量", key: "1" },
        { name: "价格", key: "2" },
        { name: "新品", key: "3" },
        {
          name: "收藏",
          key: "4",
        },
        { name: "人气", key: "5" },
      ],
      containerData: [
        { name: "非常不满" },
        { name: "不满意" },
        { name: "一般" },
        { name: "满意" },
        { name: "非常满意" },
      ],
      specialRecommendGoods: [],
      hotSellGoods: [],
      newGoods: [],
      recommendGoods: [],
      sildeList: [],
      shopImgsList: [],
      navigationTag: [],
      catListData: [],
      isHasShop: true,
      membershipLevelName: "",
    };
  },
  created() {
    //初始化数据
    this.shopList.total = 100;
    this.tab = parseInt(this.$route.query.tab);
    this.store_id = parseInt(this.$route.query.store_id);
    if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
    if (this.$route.query.start_price)
      this.priceFormData.start_price = this.$route.query.start_price;
    if (this.$route.query.end_price)
      this.priceFormData.end_price = this.$route.query.end_price;
    if (this.$route.query.acid) {
      this.stc_id = this.$route.query.acid;
      this.priceFormData.acid = this.$route.query.acid;
    } else this.priceFormData.acid = "0";
    if (this.$route.query.pid) {
      this.priceFormData.pid = this.$route.query.pid;
    } else this.priceFormData.pid = "";
    if (!this.tab || !this.store_id || this.tab > 5) {
      this.$Message.info("参数错误");
      setTimeout(() => {
        this.$router.go(-1);
      }, 2000);
    }
    switch (parseInt(this.tab)) {
      case 1:
        this.indexShopData();
        break;
      case 2:
        if (!this.headDataFlag) this.indexShopData();
        this.getNavigationTagData();

        break;
      case 3:
        if (!this.headDataFlag) this.indexShopData();
        break;
      case 4:
        if (!this.headDataFlag) this.indexShopData();
        this.shopDetailData();
        break;
      case 5:
        if (!this.headDataFlag) this.indexShopData();
        this.shopImgsData();
        break;
    }
  },
  //监听路由
  watch: {
    $route: function () {
      this.tab = parseInt(this.$route.query.tab);
      this.store_id = parseInt(this.$route.query.store_id);
      if (this.$route.query.acid) {
        this.stc_id = this.$route.query.acid;
        this.priceFormData.acid = this.$route.query.acid;
      } else this.priceFormData.acid = "0";
      if (this.$route.query.pid) {
        this.priceFormData.pid = this.$route.query.pid;
      } else this.priceFormData.pid = "";
      switch (parseInt(this.tab)) {
        case 1:
          this.indexShopData();
          break;
        case 2:
          if (!this.headDataFlag) this.indexShopData();

          this.getNavigationTagData();
          break;
        case 3:
          if (!this.headDataFlag) this.indexShopData();
          break;
        case 4:
          if (!this.headDataFlag) this.indexShopData();
          this.shopDetailData();
          break;
        case 5:
          if (!this.headDataFlag) this.indexShopData();
          this.shopImgsData();
          break;
      }
    },
  },
  methods: {
    toggle(item) {
      if (item.list.length == 0) return;
      item.show = !item.show;
    },
    gotoTarget(row) {
      console.log(row, "row----------");
      if (row.sildeUrl && row.sildeUrl.indexOf("html") > 0) {
        const router = parseAdvList([row], "sildeUrl")[0];
        if (router.to.path) {
          this.$router.push({
            path: router.to.path,
            query: router.to.query,
          });
        }
      } else {
        if (row.sildeUrl != "") window.open(row.sildeUrl, "_self");
      }
    },
    //日期格式化
    getDate: function (num) {
      var newDate = new Date();
      newDate.setTime(num * 1000);
      return newDate.toLocaleDateString();
    },
    //获取店铺详情数据
    shopDetailData: function () {
      let _params = { storeId: this.store_id };
      getStoreDetail(_params).then((json) => {
        if (json.resCode == "1") {
          this.shopInfoData = json.data;
          this.shopInfoData.storeCredit = json.data.storeCredit.toFixed(2);
          console.log(this.headData, "this.headData");
          // 获取用户等级
          getMemberLevel({ loginName: this.shopInfoData.userName }).then(
            (res) => {
              this.membershipLevelName = res.data.storeLevelName;
            }
          );
        } else {
          this.$Message.info(json.resDesc);
        }
      });
    },
    getNavigationTagData: function () {
      getAllCatList({
        storeId: this.store_id,
        catId: "0",
      }).then((res) => {
        if (res.resCode === 1) {
          this.navigationTag = res.data; // 商品分类信息

          var obj = [];
          var obj2 = [];
          for (var i in this.navigationTag) {
            if (this.navigationTag[i].storeCatPid == 0) {
              obj.push(this.navigationTag[i]);
            } else {
              obj2.push(this.navigationTag[i]);
            }
          }
          for (var k in obj) {
            obj[k].show = true;
            obj[k].list = [];
            for (var j in obj2) {
              if (obj2[j].storeCatPid == obj[k].storeCatId) {
                obj[k].list.push(obj2[j]);
                if (obj[k].list.length) {
                  obj[k].show = false;
                }
              }
            }
          }
          const all = {
            list: [],
            show: true,
            sort: 1,
            storeCatId: "0",
            storeCatName: "全部商品",
            storeId: this.store_id,
          };
          obj.splice(0, 0, all);
          this.catListData = JSON.parse(JSON.stringify(obj));

          this.shopListData(1);
        } else {
          this.$Message.info(json.resDesc);
        }
      });
      /*getNavigationTag(_params).then((json) => {
       if (json.resCode == '1') {
       this.navigationTag = json.data.navigationTag;
       if (!this.$route.query.nav_url) {
       for (var i in this.navigationTag) {
       if (this.navigationTag[i].name == '全部') {
       this.priceFormData.nav_url = this.navigationTag[i].nav_url;
       this.navigationTag[i].acid = '000'
       }
       console.log(this.navigationTag[i].name,this.query.name)
       if(this.navigationTag[i].name == this.query.name ){
       priceFormData.acid = i
       }
       }
       }

       // 根据查询参数设置默认的搜索菜单 tab ( 修改 魏强 2018.5.25)
       for (var i in this.navigationTag) {
       if(this.navigationTag[i].name == this.query.name ){
       this.priceFormData.acid = i
       }
       }
       //( 修改 魏强 2018.5.25) end
       this.shopListData(1);
       } else {
       this.$Message.info(json.resDesc);
       }
       });*/
    },
    shopImgsData: function () {
      let _params = { storeId: this.store_id };
      getStoreImgs(_params).then((json) => {
        if (json.resCode == "1") {
          this.shopImgsList = json.data;
        } else {
          this.$Message.info(json.resDesc);
        }
      });
    },
    handleInput(num) {
      this.priceFormData.start_price = this.priceFormData.start_price.replace(
        /[^\d]/g,
        ""
      );
      this.priceFormData.end_price = this.priceFormData.end_price.replace(
        /[^\d]/g,
        ""
      );
    },
    priceSearch: function () {
      this.changepage(1);
    },
    setForm: function (key) {
      this.priceFormData.key = key;
      if (key == this.priceFormData.oldKey) {
        if (this.priceFormData.order == "asc")
          this.priceFormData.order = "desc";
        else this.priceFormData.order = "asc";
      } else {
        this.priceFormData.order = "asc";
      }
      this.changepage(1);
      this.priceFormData.oldKey = key;
    },
    setNavigationTag(item, index) {
      if (item.storeCatId == "0") {
        this.priceFormData.pid = "";
        this.priceFormData.acid = item.storeCatId;
      } else {
        this.priceFormData.acid = item.storeCatId;
        this.priceFormData.pid = item.storeCatPid;
      }
      this.changepage(1);
    },
    changeKeyword(evtValue) {
      this.keyword = evtValue;
    },
    getShopListData(evtValue) {
      if (this.tab == 2) this.shopListData(1);
      else this.changeTab(2);
    },
    applyHeadData(evtValue) {
      this.indexShopData();
    },
    changeTab: function (n, v) {
      this.tab = parseInt(n);
      if (v) this.tagid = parseInt(v);
      else this.tagid = "";
      this.indexShopData();
      this.$router.push({ query: { tab: this.tab, store_id: this.store_id } });
    },
    changepage(index) {
      this.$refs["pages"].currentPage = index;
      this.shopListData(index);
    },
    indexShopData: function () {
      let _params = {
        storeId: this.store_id,
      };
      getStoreIndexDetail(_params).then((json) => {
        if (json.resCode == "1") {
          this.isHasShop = true;
          this.headDataFlag = true;
          this.headData = json.data.storeDetailDTO;
          this.shopInfoData.passTime = this.getDate(this.headData.passTime);
          this.sildeList = json.data.storeSildeList;
          this.specialRecommendGoods =
            json.data.specialRecommendGoodsList.slice(0, 5);
          this.hotSellGoods =
            json.data.hotSellGoodsList.length > 5
              ? json.data.hotSellGoodsList.slice(0, 5)
              : json.data.hotSellGoodsList;
          this.newGoods =
            json.data.newGoodsList.length > 2
              ? json.data.newGoodsList.slice(0, 2)
              : json.data.newGoodsList;
          this.recommendGoods = json.data.recommendGoodsList.slice(0, 5);
          this.shopCredit.storeDesccredit =
            json.data.storeDetailDTO.storeDesccredit;
          this.shopCredit.storeDeliverycredit =
            json.data.storeDetailDTO.storeDeliverycredit;
          this.shopCredit.storeServicecredit =
            json.data.storeDetailDTO.storeServicecredit;
          // 没有店铺的时候做页面控制
        } else {
          this.isHasShop = false;
          this.$Message.info(json.resDesc);
        }
      });
    },
    shopListData: function (pageNo) {
      let _params = {
        pageNo: pageNo,
        pageSize: this.pageSize,
        storeId: this.store_id,
        tagId: this.tagid,
        keyword: this.keyword,
        startPrice: this.priceFormData.start_price,
        endPrice: this.priceFormData.end_price,
        key: this.priceFormData.key,
        order: this.priceFormData.order,
        stcId: this.priceFormData.acid,
        /*"nav_url": this.priceFormData.nav_url*/
      };
      getStoreGoodList(_params).then((json) => {
        if (json.resCode == 1) {
          this.dataTotal = json.data.total;
          this.shopList = json.data.list;
        } else {
          this.$Message.info(json.resDesc);
        }
      });
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/shop.css";
</style>



// WEBPACK FOOTER //
// shop-detail.vue?ed5b1b98